module.exports = __webpack_public_path__ + "img/icon-2.d83b694c.svg";